<template>
    <div class="upload-requests">
        <div class="upload-requests-count">
            <test-result-circle class="upload-requests-count-item" result="MTR_RES_PASSED"
                                :count="getSuccessRequestsCount(uploadRequests)" hide-if-zero/>
        </div>
        <div class="upload-requests-count">
            <test-result-circle class="upload-requests-count-item" result="MTR_RES_INFO"
                                :count="getNoXmlRequestsCount(uploadRequests)" hide-if-zero/>
        </div>
        <div class="upload-requests-count">
            <test-result-circle class="upload-requests-count-item" result="MTR_RES_FAILED"
                                :count="getFailedRequestsCount(uploadRequests)" hide-if-zero/>
        </div>
    </div>
</template>
<script>
    import TestResultCircle from "./TestResultCircle"
    import {PARSER_RESULT_CODES} from "@/utils/constants";

    export default {
        name: 'UploadRequestsResultsCount',
        components: {TestResultCircle},
        props: {
            uploadRequests: {}
        },
        methods: {
            getSuccessRequestsCount() {
                return this.uploadRequests
                    .filter(item => PARSER_RESULT_CODES.SUCCESS.includes(item.result))
                    .length;
            },
            getNoXmlRequestsCount() {
                return this.uploadRequests
                    .filter(item => PARSER_RESULT_CODES.NO_XML.includes(item.result))
                    .length;
            },
            getFailedRequestsCount() {
                return this.uploadRequests
                    .filter(item => PARSER_RESULT_CODES.FAILURE.includes(item.result))
                    .length;
            },
        }
    }
</script>
<style lang="scss" scoped>
    .upload-requests-count {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: row;
    }

    .upload-requests-count-item {
        margin: 0 0.3em;
    }

    .upload-requests {
        display: flex;
        align-items: start;
        justify-content: start;
        flex-direction: row;
    }
</style>